import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Translation resources
const resources = {
  en: {
    translation: {
      // Common
      "loading": "Loading",
      "next": "Next",
      "verify": "Verify",
      "connectButton": "Connect",
      "connected": "Connected",
      "cancel": "Cancel",
      "close": "Close",
      "retry": "Retry",
      "back": "Back",
      
      // Phone Number Page
      "phoneNumber": {
        "title": "What's your phone number?",
        "placeholder": "Phone number",
        "next": "Next",
        "invalidFormat": "Please enter a valid phone number"
      },
      
      // Phone Verification Page
      "phoneVerification": {
        "title": "Enter your verification code",
        "didntReceive": "Didn't receive a code?",
        "resendCode": "Resend code",
        "verify": "Verify",
        "invalidCode": "Please enter the complete 5-digit code",
        "verificationSuccess": "Phone number verified successfully!",
        "networkError": "Network error. Please try again.",
        "invalidOrExpired": "Invalid or expired verification code",
        "newCodeSent": "New verification code sent!",
        "failedToResend": "Failed to resend code"
      },
      
      // Connect Page
      "connect": {
        "title": "Build what matters",
        "subtitle": "",
        "connectWithGmail": "Connect with Gmail",
        "connectWithOutlook": "Connect with Microsoft",
        "orDivider": "or",
        "emailPlaceholder": "Email address",
        "sendPasscode": "Send passcode",
        "checkEmail": "Check your email for a 6-digit passcode",
        "passcodePlaceholder": "Enter passcode",
        "verifyPasscode": "Log in with passcode",
        "resendPasscode": "Resend passcode",
        "useDifferentEmail": "Use a different email",
        "invalidEmail": "Please enter a valid email address",
        "passcodeSent": "Passcode sent. Check your email.",
        "termsText": "By connecting, you agree to our",
        "termsOfService": "Terms",
        "and": "and",
        "privacyPolicy": "Privacy Policy",
        "linkDescription": ""
      },
      
      // Integrations Page
      "integrations": {
        "title": "Service Integrations",
        "subtitle": "Connect your Google, Microsoft, Facebook, and Apple services to enable AI-powered calendar and email management",
        "mobilePhone": "Mobile Phone",
        "mobilePhoneDesc": "Connect your phone for AI assistance",
        "google": "Google",
        "googleDesc": "Manage your meetings and events",
        "microsoft": "Microsoft",
        "microsoftDesc": "Outlook calendar integration",
        "appleICloud": "Apple iCloud",
        "appleICloudDesc": "Apple calendar & contacts integration",
        "appleMessages": "Open Messages",
        "appleMessagesDesc": "Click here to open Apple Messages to chat"
      },
      
      // Navigation
      "nav": {
        "projects": "Projects",
        "integrations": "Integrations",
        "billing": "Billing",
        "usage": "Usage",
        "contact": "Contact",
        "logout": "Log Out"
      },
      
      // Error messages
      "errors": {
        "networkError": "Network error. Please try again.",
        "invalidInput": "Invalid input. Please check and try again.",
        "sessionExpired": "Session expired. Please log in again.",
        "unknownError": "An unknown error occurred. Please try again."
      }
    }
  },
  zh: {
    translation: {
      // Common
      "loading": "加载中",
      "next": "下一步",
      "verify": "验证",
      "connectButton": "连接",
      "connected": "已连接",
      "cancel": "取消",
      "close": "关闭",
      "retry": "重试",
      "back": "返回",
      
      // Phone Number Page
      "phoneNumber": {
        "title": "请输入您的手机号码",
        "placeholder": "手机号码",
        "next": "下一步",
        "invalidFormat": "请输入有效的手机号码"
      },
      
      // Phone Verification Page
      "phoneVerification": {
        "title": "请输入验证码",
        "didntReceive": "没有收到验证码？",
        "resendCode": "重新发送验证码",
        "verify": "验证",
        "invalidCode": "请输入完整的5位验证码",
        "verificationSuccess": "手机号码验证成功！",
        "networkError": "网络错误，请重试。",
        "invalidOrExpired": "验证码无效或已过期",
        "newCodeSent": "新验证码已发送！",
        "failedToResend": "重新发送验证码失败"
      },
      
      // Connect Page
      "connect": {
        "title": "连接您的手机",
        "subtitle": "将您的日历、邮件和日程安排整合在一个地方。",
        "connectWithGmail": "连接 Gmail",
        "connectWithOutlook": "连接 Outlook",
        "orDivider": "或",
        "emailPlaceholder": "电子邮箱",
        "sendPasscode": "发送验证码",
        "checkEmail": "请查收邮件中的 6 位验证码",
        "passcodePlaceholder": "输入验证码",
        "verifyPasscode": "使用验证码登录",
        "resendPasscode": "重新发送",
        "useDifferentEmail": "使用其他邮箱",
        "invalidEmail": "请输入有效的邮箱地址",
        "passcodeSent": "验证码已发送，请查收邮件。",
        "termsText": "连接即表示您同意我们的",
        "termsOfService": "服务条款",
        "and": "和",
        "privacyPolicy": "隐私政策",
        "linkDescription": "我们将您的手机号码与您的邮箱账户关联，以实现安全认证和通信管理。"
      },
      
      // Integrations Page
      "integrations": {
        "title": "服务集成",
        "subtitle": "连接您的 Google、Microsoft、Facebook 和 Apple 服务，启用 AI 驱动的日历和邮件管理",
        "mobilePhone": "手机",
        "mobilePhoneDesc": "连接您的手机获得 AI 助手",
        "google": "Google",
        "googleDesc": "管理您的会议和活动",
        "microsoft": "Microsoft",
        "microsoftDesc": "Outlook 日历集成",
        "appleICloud": "Apple iCloud",
        "appleICloudDesc": "Apple 日历和联系人集成",
        "appleMessages": "Apple 信息",
        "appleMessagesDesc": "打开 Apple 信息进行聊天"
      },
      
      // Navigation
      "nav": {
        "integrations": "集成",
        "billing": "账单",
        "contact": "联系",
        "logout": "退出登录"
      },
      
      // Error messages
      "errors": {
        "networkError": "网络错误，请重试。",
        "invalidInput": "输入无效，请检查后重试。",
        "sessionExpired": "会话已过期，请重新登录。",
        "unknownError": "发生未知错误，请重试。"
      }
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    
    // Language detection options
    detection: {
      order: ['navigator', 'localStorage', 'sessionStorage', 'cookie', 'htmlTag'],
      lookupLocalStorage: 'i18nextLng',
      lookupSessionStorage: 'i18nextLng',
      lookupCookie: 'i18nextLng',
      caches: ['localStorage'],
      excludeCacheFor: ['cimode'],
    },
    
    fallbackLng: 'en',
    debug: false,
    
    interpolation: {
      escapeValue: false, // React already does escaping
    },
    
    // Language mapping
    load: 'languageOnly', // Use 'zh' instead of 'zh-CN'
    preload: ['en', 'zh'],
  });

export default i18n;
